import { listTimeZones as listTimezones } from "timezone-support";
export const getIanaTimezones = (): string[] => {
  /**
   * Remove time zones that we don't want to display.
   */
  const rejectUncommonTimezones = (timezones: string[]): string[] => timezones.filter(timezone => !/(CET|CST|EET|Etc|EST|HST|MST|PST|WET|MET|Antarctica).*/.test(timezone));
  const filteredTimezones = rejectUncommonTimezones(listTimezones());
  const sortedTimezones = filteredTimezones.sort((a, b) => a.localeCompare(b));
  return sortedTimezones;
};